export default __webpack_public_path__ + "static/how-to-сreate-a-converting-landing-page-design-6d6e694c48983dffe0ee9e2383c754b8.png";